import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';

import { NavListItem } from '../NavList';

const itemStyle = css`
  display: block;
  width: 100%;
  margin: 0;
  color: ${theme.colors.neutral900};

  line-height: 0;
  font-family: ${theme.font.family.default};
  font-weight: ${theme.font.weight.light};
  font-size: ${theme.font.size.sm};

  @media (min-width: ${theme.breakpoints.md}px) {
    display: block;
    margin: 0;
    width: 100%;
  }

  &:first-child {
    margin: 0;
  }

  &:last-child {
      margin: 0;
      padding-bottom: 8px;
    }
  }

  & a,
  & span {
    display: inline-block;
    padding: 8px 40px;
    width: 100%;
    line-height: ${theme.lineHeight.lg};
    color: inherit;
    font-size: inherit;
    text-decoration: none;
    &:hover,
    &:focus{
      background-color: ${theme.colors.neutral50};
    }

    &:active {
      background-color: ${theme.colors.neutral100};
    }

    & i {
      position: relative;
      vertical-align: middle;
      top: -1px;
      right: 4px;
      font-size: ${theme.font.size.sm};
    }
  }
`;

const MobileNavMenuListItem = ({ className, ...props }) => (
  <NavListItem className={cx(itemStyle, className)} {...props} />
);

MobileNavMenuListItem.defaultProps = {
  className: '',
};

MobileNavMenuListItem.propTypes = {
  className: PropTypes.string,
};

export default MobileNavMenuListItem;
